import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { Product } from '../../catalog/product/product.decorator';
import { NTextBox, TextBoxComponent } from '../../common/text-box/text-box.component';
import { defaultImage } from '../../icms.config';

let uid = 0;

export namespace NCmsUGC {
    export const MODAL_ID = 'ugc-modal';
    export interface IComponentData extends NICmsContentComponent.IData, NTextBox.IData {
        links: IUGC[];
    }
    export interface IUGC {
        tagName?: string;
        tagLink?: string;
        image: string;
    }
    export interface IModalData {
        title: string;
        products: Product<IProductDataV2>[];
    }
}

@ICmsComponent<CmsUGCComponent>({
    id: 'ugc',
    name: 'User Generated Content',
    tags: ['carousel', 'ugc', 'links', 'User Generated Content'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'text-box',
            title: 'Text box component'
        },
        ...NTextBox.getFields(false, false),
        // links
        {
            type: NICmsContentField.EFieldType.label,
            key: 'links',
            title: 'Links carousel'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Links',
            itemName: 'Link',
            itemNameField: 'tagName',
            required: true,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'tagName',
                    title: 'Tag name',
                    default: 'Tag Name'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'tagLink',
                    title: 'Tag link'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image',
                    default: defaultImage,
                    required: true
                }
            ]
        }
    ]
})
@Component({
    standalone: true,
    imports: [DfModuleImageModule, DfUiCarouselModule, HrefComponent, TextBoxComponent, NgClass, ICmsClientModule],
    selector: 'cms-ugc',
    templateUrl: './cms-ugc.html',
    styleUrl: './cms-ugc.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsUGCComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsUGC.IComponentData;

    protected uid = uid++;

    get pcSlides() {
        return [1.065, 2.2, 4.2, 5.7][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return '16px';
    }
}
